import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SignupUserService as NewSignupUserService } from '@app/modules/signup-new/services/signup-user.service';
import { SignupWizardService as NewSignupWizardService } from '@app/modules/signup-new/services/signup-wizard.service';
import { SignupWizardService } from '../signup-wizard.service';

@Component({
  standalone: false,
  selector: 'sbnb-signup-continue',
  templateUrl: './signup-continue.component.html',
  styleUrls: ['./signup-continue.component.scss'],
})
export class SignupContinueComponent implements OnInit {
  continueToken: string; // the magic token contained in the email sent to the user to allow them to return
  loading: boolean;
  error: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly wizard: SignupWizardService,
    private readonly newSignupWizardService: NewSignupWizardService,
    private readonly newSignupUserService: NewSignupUserService,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.loading = true;
      this.continueToken = params['token'];

      this.wizard.continueReturningUser(this.continueToken).subscribe((res) => {
        this.loading = false;

        if ('error' in res) {
          this.error = res.message;
          return;
        }

        const user = res;

        if (['B', 'C'].includes(user.flow)) {
          this.newSignupUserService.user$.next(user);
          this.newSignupWizardService.init();
          return;
        }

        switch (user.current_step) {
          case 2:
            this.router.navigate(['/user/register/welcome']);
            break;

          case 3:
            this.router.navigate(['/user/register/start']);
            break;

          case 4:
            this.router.navigate(['/user/register/properties']);
            break;

          case 5:
            this.router.navigate(['/user/register/channels']);
            break;

          case 6:
            this.router.navigate(['/user/register/password']);
            break;

          case 7:
            this.router.navigate(['/user/register/trial']);
            break;

          case 8:
            this.router.navigate(['/user/register/messaging-rules']);
            break;

          case 9:
          case 10:
            this.router.navigate(['/user/register/messaging-rules']);
            break;

          default:
            this.error = `We're having some trouble continuing your application. We've logged this, please reach out to support if this keeps happening.`;
            break;
        }
      });
    });
  }
}
